(() => {
  angular
    .module('complianceFrameworkApp.core', [
      /* Angular modules */
      'ngResource',
      'ngAnimate',

      /* 3rd-part modules */
      'ui.router',
      'ngFlash',
      'angularTrix',
      'checklist-model',
      'ngFileUpload',
      'truncate',
      'ngAvatar',
      'datePicker',
      'angularUtils.directives.dirPagination',
      '720kb.datepicker',
      'stickyfill',
      'angular.filter',
      'angularMoment'
    ]);
})();
